var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1667 13.5L24.0833 3L6 13.5V34.5L24.0833 45L42.1667 34.5V13.5ZM40.1615 14.6667L24.0875 5.33333L8.01338 14.6667V33.3333L24.0875 42.6667L40.1615 33.3333V14.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0648 7.66992L38.1297 15.8366V32.1699L24.0648 40.3366L10 32.1699V15.8366L24.0648 7.66992ZM26.0332 28.2961C26.5746 27.5156 27.4781 26.9988 28.5012 26.9988C30.157 26.9988 31.4965 28.3453 31.4965 30.0012C31.4965 31.657 30.1535 33 28.4977 33C26.8418 33 25.4988 31.657 25.4988 30.0012C25.4988 29.9871 25.5006 29.973 25.5023 29.959C25.5041 29.9449 25.5059 29.9309 25.5059 29.9168L18.5098 26.2113C17.9754 26.6965 17.2758 26.9988 16.4988 26.9988C14.843 26.9988 13.5 25.6559 13.5 24C13.5 22.3441 14.843 21.0012 16.5023 21.0012C17.2793 21.0012 17.9789 21.3035 18.5133 21.7887L25.5094 18.0832C25.5094 18.0691 25.5076 18.0551 25.5059 18.041C25.5041 18.027 25.5023 18.0129 25.5023 17.9988C25.5023 16.343 26.8453 15 28.5012 15C30.157 15 31.5 16.3465 31.5 18.0023C31.5 19.6582 30.157 21.0012 28.5012 21.0012C27.4746 21.0012 26.5746 20.4879 26.0332 19.7039L19.3852 23.223C19.4555 23.4727 19.5012 23.7293 19.5012 24C19.5012 24.2707 19.452 24.5273 19.3852 24.777L26.0332 28.2961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralPoints);
export default __webpack_public_path__ + "static/media/referral-points.053ead68fba8fc0e37c93c3b03bbaec2.svg";
export { ForwardRef as ReactComponent };